import type React from 'react'

import { cn } from 'utils/cn'

type WarningBgIfEmptyProps = {
  checkValue: unknown
  className?: string
  children: React.ReactNode
}

export const WarningBgIfEmpty: React.FC<WarningBgIfEmptyProps> = ({ checkValue, children, className }) => {
  const warningClassname = cn(
    {
      'bg-orange-50 p-2 -m-2': !checkValue,
    },
    className,
  )
  return <div className={warningClassname}>{children}</div>
}
